import { useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import PricelistsIndex from '../../components/pricelists/PricelistsIndex'
import { usePricelists } from '../../hooks/usePricelists'
import { IconChecklistCircle } from 'components/icons'
import { stockPricelistItems } from 'constants/breadcrumb/items'

export default function Pricelists() {
  const params = useParams()
  const location = useLocation()
  const navigate = useNavigate()

  const {
    toast,
    toastContainer,
    isLoadingFetchProductPrice,
    isFailedFetchProductPrice,
    productsPrice,
    limitPageProductsPrice,
    currentPageProductsPrice,
    totalRowsProductsPrice,
    sortProductsPrice,
    directionProductsPrice,
    productPriceStatus,
    onChangeProductsPriceStatus,
    onChangeCurrentPageProductsPrice,
    onChangeLimitPageProductsPrice,
    onFetchProductPrice,
    onChangeSortStockPrice,
  } = usePricelists()

  useEffect(() => {
    if (location && location.state && location.state.actionType) {
      toast(
        `${location.state.message}`,
        location.state.actionType,
        <IconChecklistCircle color="white" />,
      )
    }
  }, [])

  return (
    <div className="content-wrapper" data-testid="pricelist_wrapper">
      {toastContainer}
      <PricelistsIndex
        isLoading={isLoadingFetchProductPrice}
        isFailed={isFailedFetchProductPrice}
        data={productsPrice}
        totalRows={totalRowsProductsPrice}
        page={currentPageProductsPrice}
        limit={limitPageProductsPrice}
        navigationsItem={stockPricelistItems}
        orderColumn={sortProductsPrice}
        orderDirection={directionProductsPrice}
        status={productPriceStatus}
        onChangeProductsPriceStatus={onChangeProductsPriceStatus}
        onChangePage={onChangeCurrentPageProductsPrice}
        onChangeLimitPage={onChangeLimitPageProductsPrice}
        onFetchProductPrice={onFetchProductPrice}
        onChangeSortStockPrice={onChangeSortStockPrice}
        onClickCreate={() =>
          navigate(`/inventory/stock-location/stock/${params.id}/pricelist/create`)
        }
        onClickEdit={selected =>
          navigate(
            `/inventory/stock-location/stock/${params.id}/pricelist/edit?priceListId=${selected.pricelistId}&stockId=${selected.stockId}`,
          )
        }
      />
    </div>
  )
}
